import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/modules/shared/ui/components/dialog"
import { Button } from "@/modules/shared/ui/components/button"

interface DuplicateVacancyDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onEdit: () => void
  onContinue: () => void
  vacancyTitle?: string
  isContinuing?: boolean
}

export function DuplicateVacancyDialog({
  open,
  onOpenChange,
  onEdit,
  onContinue,
  vacancyTitle,
  isContinuing = false,
}: DuplicateVacancyDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] bg-card">
        <DialogHeader>
          <DialogTitle>Duplicate Vacancy</DialogTitle>
          <DialogDescription className="text-muted-foreground mt-2">
            {vacancyTitle ? (
              <>
                You are duplicating{" "}
                <span className="font-semibold text-foreground">
                  {vacancyTitle}
                </span>
                . Would you like to edit the vacancy before creating it, or
                continue with the same details?
              </>
            ) : (
              "Would you like to edit the vacancy before creating it, or continue with the same details?"
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4 gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isContinuing}
          >
            Cancel
          </Button>
          <Button
            variant="outline"
            onClick={onEdit}
            disabled={isContinuing}
          >
            Edit
          </Button>
          <Button
            className="bg-blue-600 hover:bg-blue-700 text-white"
            onClick={onContinue}
            disabled={isContinuing}
          >
            {isContinuing ? "Duplicating..." : "Continue"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
